<template>
    <div class="">
        <!-- region first: it also narrows the server names in the dropdown below -->
        <RegionTabs v-model="selectedRegion" :counts="regionCounts" class="pt-2" />
        <div class="flex justify-between items-center py-2 flex-wrap">
            <div class="flex flex-wrap gap-4 py-2">
                <SearchBar :region="selectedRegion" @server-selected="serverSelectedHandeler">
                </SearchBar>

                <div v-if="selectedServerName !== ''" class="w-56 pr-5 text-xs">
                    Usage Status
                    <v-select v-model="selectedSaleStatus" :items="saleStatusList" density="compact" variant="outlined"
                        rounded="0" placeholder="Select Sale Status" style="padding-top: 0px;padding-bottom: 0px;">
                    </v-select>
                </div>
                <div v-if="selectedServerName !== ''" class="w-56 pr-5 text-xs">
                    Proxy Connect Status
                    <v-select v-model="selectedConnStatus" :items="connectStatusList" density="compact" rounded="0"
                        variant="outlined" placeholder="Select Conn Status"
                        style="padding-top: 0px;padding-bottom: 0px;">
                    </v-select>
                </div>
            </div>
            <div v-if="selectedServerName !== ''">
                <v-btn icon="mdi-delete" size="small" style="outline: none;" @click="deleteProxies"
                    class="mr-5 bg-dark text-light"></v-btn>
                <v-btn v-if="selectedServerName !== 'All' && selectedServerType === 'PROPROXYUI'" icon="mdi-plus" size="small" style="outline: none;"
                    class="bg-dark text-light" @click="ppuiRef.openAdd()"></v-btn>
                <v-btn v-if="selectedServerName !== 'All' && selectedServerType !== 'PROPROXYUI'" icon="mdi-plus" size="small" style="outline: none;"
                    data-bs-toggle="modal" 
                    :data-bs-target="(selectedServerType === 'X_PROXY' || selectedServerType === 'XPROXY_NEW' || selectedServerType === 'XPROXY_NEW_2PORT') ? '#xproxyAddModal' :
                                     selectedServerType === 'PROXYSMART' ? '#proxysmartAddModal' :
                                ''"
                    class="bg-dark text-light" @click="addProxy"></v-btn>
            </div>
        </div>
        <div v-if="loading === true" class=" flex items-center justify-center absolute custom-style " >
            <img src="../../../assets/loading.gif" class="w-[50px]"/>
        </div>
        <ProProxyUiTable v-if="selectedServerType === 'PROPROXYUI'" ref="ppuiRef" :selectedServerName="selectedServerName"
            :selectedSaleStatus="selectedSaleStatus" :selectedConnStatus="selectedConnStatus" :selectedRegion="selectedRegion" />
        <TableView v-else ref="tableViewRef" :selectedConnStatus="selectedConnStatus" :selectedServerName="selectedServerName"
            :selectedSaleStatus="selectedSaleStatus" :selectedServerType="selectedServerType" :selectedRegion="selectedRegion"
            class="border bg-white text-black" />
    </div>
    <div>
        <XProxyAddNewOneDialog @close="addNewOneDialogFlag = false" :serverName="selectedServerName" :serverType="selectedServerType" />
        <ProxySmartAddNewOneDialog @close="addNewOneDialogFlag = false" :serverName="selectedServerName" />
    </div>
</template>
<script setup>
import { ref, computed } from 'vue';
import RegionTabs from '@/components/Common/RegionTabs.vue';
import { countRegions } from '@/helpers/region';
import { useAdminProxyStore, useAlertStore } from "@/stores"
import { storeToRefs } from 'pinia';
import SearchBar from './SearchBar.vue';
import TableView from "./TableView.vue";
import ProProxyUiTable from "./ProProxyUiTable.vue";
import XProxyAddNewOneDialog from "./Modals/AddNewOneDialog-XProxy.vue"
import ProxySmartAddNewOneDialog from "./Modals/AddNewOneDialog-ProxySmart.vue"

import { watchEffect } from 'vue';
import { watch } from 'vue';

const adminProxyStore = useAdminProxyStore()
const { xProxies, smartProxies, ppuiProxies, loading } = storeToRefs(adminProxyStore)
// All / UK / USA / Other, by the country of each proxy's server (opens on All)
const selectedRegion = ref('all')
const regionCounts = computed(() => countRegions([...(xProxies.value || []), ...(smartProxies.value || []), ...(ppuiProxies.value || [])], (proxy) => proxy.modem_country))
const addNewOneDialogFlag = ref(false)
const selectedServerName = ref("All")
const selectedServerType = ref("X_PROXY")


let loadedServerName = null
const serverSelectedHandeler = (server) => {
    if (server) {
        selectedServerName.value = server.name
        selectedServerType.value = server.type
        // the list only depends on the server; a type change is filtered in the browser
        if (server.name !== loadedServerName) {
            loadedServerName = server.name
            adminProxyStore.loadProxies(server.name)
        }
    }
}
const addProxy = () => {
    addNewOneDialogFlag.value = true
}
const saleStatusList = ref(['All', 'AVAILABLE', 'USED'])
const connectStatusList = ref(['All', 'CONNECTED', 'DISCONNECTED', 'PAUSED', 'MAX CONNS'])   // MAX CONNS: ProxySmart ports at their connection limit
const selectedSaleStatus = ref('All')
const selectedConnStatus = ref('All')
// MAX CONNS filters on live counts, so reload with complete numbers when it is picked
watch(selectedConnStatus, (v) => { if (v === 'MAX CONNS') adminProxyStore.loadProxies(selectedServerName.value || 'All', { waitConns: true }) })

const selectedItems = ref([])

const tableViewRef = ref(null)
const ppuiRef = ref(null)   // ProProxyUI ports table
const deleteProxies = () => {
    if (selectedServerType.value === 'PROPROXYUI') ppuiRef.value.deleteProxies()
    else tableViewRef.value.deleteProxies()
}
</script>

<style scoped>
.custom-style {
    width: -webkit-fill-available; /* Safari/WebKit */
    height: -webkit-fill-available; /* Safari/WebKit */
    width: -moz-available; /* Firefox */
    height: -moz-available; /* Firefox */
    width: fill-available; /* Standard syntax, for future compatibility */
    height: fill-available; /* Standard syntax, for future compatibility */
}
</style>